import "moment-timezone";
import React, { Component } from "react";
import "react-block-ui/style.css";
import { Nav, NavItem } from "react-bootstrap";
import { Route, Switch } from "react-router";
import { Link } from "react-router-dom";
import ReportingBulkMessages from "./ReportingBulkMessages";
import ReportingDaysBeforeSeminar from "./ReportingDaysBeforeSeminar";
import ReportingDaysBeforeTCS from "./ReportingDaysBeforeTCS";
import ReportingDeadDeals from "./ReportingDealDeals";
import ReportingFunnels from "./ReportingFunnels";
import ReportingSales from "./ReportingSales";
import ReportingSalesPersonResults from "./ReportingSalesPersonResults";
import ReportingSingleParentAttending from "./ReportingSingleParentAttending";
import ReportingTCSBookedBySalesPerson from "./ReportingTCSBookedBySalesPerson";
import ReportingTCSReasons from "./ReportingTCSReasons";
import ReportingConfirmationCallScores from "./ReportingConfirmationCallScores";
import ReportingDealComments from "./ReportingDealComments";
import ReportingDownloadTranscripts from "./ReportingDownloadTranscripts";

class Reporting extends Component {
  constructor(props) {
    super(props);

    const { view } = props.match.params;
    this.state = { activeView: view, stats: {} };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (this.props.view !== prevProps.view) {
      this.setState({ view: this.props.view });
    }
  }

  handleSelect = eventKey => {
    this.setState({ activeView: eventKey }, () => {});
  };

  render() {
    return (
      <div>
        <h1 className="first-title" style={{ marginBottom: "20px" }}>
          Reporting
        </h1>
        <div className="row">
          <div className="col-md-12">
            <Nav
              bsStyle="tabs"
              activeKey={this.state.activeView}
              onSelect={this.handleSelect.bind(this)}
            >
              <NavItem
                eventKey="funnels"
                componentClass={Link}
                to={`/m1/reporting/funnels`}
                href={`/m1/reporting/funnels`}
              >
                Funnels
              </NavItem>
              <NavItem
                eventKey="days_before_seminar"
                componentClass={Link}
                to={`/m1/reporting/days_before_seminar`}
                href={`/m1/reporting/days_before_seminar`}
              >
                Days Before Seminar
              </NavItem>
              <NavItem
                eventKey="days_before_tcs_web"
                componentClass={Link}
                to={`/m1/reporting/days_before_tcs_web`}
                href={`/m1/reporting/days_before_tcs_web`}
              >
                Days Before TCS (web)
              </NavItem>
              <NavItem
                eventKey="days_before_tcs_seminar"
                componentClass={Link}
                to={`/m1/reporting/days_before_tcs_seminar`}
                href={`/m1/reporting/days_before_tcs_seminar`}
              >
                Days Before TCS (seminar)
              </NavItem>
              <NavItem
                eventKey="tcs_booked_by_sales_person"
                componentClass={Link}
                to={`/m1/reporting/tcs_booked_by_sales_person`}
                href={`/m1/reporting/tcs_booked_by_sales_person`}
              >
                TCS Booked by Sales Person
              </NavItem>
              <NavItem
                eventKey="tcs_reasons"
                componentClass={Link}
                to={`/m1/reporting/tcs_reasons`}
                href={`/m1/reporting/tcs_reasons`}
              >
                TCS Reasons
              </NavItem>
              <NavItem
                eventKey="sales_person_results"
                componentClass={Link}
                to={`/m1/reporting/sales_person_results`}
                href={`/m1/reporting/sales_person_results`}
              >
                Sales Person Results
              </NavItem>
              <NavItem
                eventKey="bulk_messages"
                componentClass={Link}
                to={`/m1/reporting/bulk_messages`}
                href={`/m1/reporting/bulk_messages`}
              >
                Bulk Messages
              </NavItem>
              <NavItem
                eventKey="dead_deals"
                componentClass={Link}
                to={`/m1/reporting/dead_deals`}
                href={`/m1/reporting/dead_deals`}
              >
                Dead Deals
              </NavItem>
              <NavItem
                eventKey="single_parent_attending"
                componentClass={Link}
                to={`/m1/reporting/single_parent_attending`}
                href={`/m1/reporting/single_parent_attending`}
              >
                Single Parent Attending
              </NavItem>
              <NavItem
                eventKey="sales"
                componentClass={Link}
                to={`/m1/reporting/sales`}
                href={`/m1/reporting/sales`}
              >
                Generics Flags
              </NavItem>
              <NavItem
                eventKey="confirmation_call_scores"
                componentClass={Link}
                to={`/m1/reporting/confirmation_call_scores`}
                href={`/m1/reporting/confirmation_call_scores`}
              >
                Confirmation Call Scores
              </NavItem>
              <NavItem
                eventKey="deal_comments"
                componentClass={Link}
                to={`/m1/reporting/deal_comments`}
                href={`/m1/reporting/deal_comments`}
              >
                Deal Comments/Reporting
              </NavItem>
              <NavItem
                eventKey="download_transcripts"
                componentClass={Link}
                to={`/m1/reporting/download_transcripts`}
                href={`/m1/reporting/download_transcripts`}
              >
                Download Transcripts
              </NavItem>
            </Nav>
            <div className="tab-content">
              <Switch>
                <Route
                  path={"/m1/reporting/funnels"}
                  render={props => (
                    <ReportingFunnels view={this.state.activeView} {...props} />
                  )}
                />
                <Route
                  path={"/m1/reporting/days_before_seminar"}
                  render={props => (
                    <ReportingDaysBeforeSeminar
                      view={this.state.activeView}
                      {...props}
                    />
                  )}
                />
                <Route
                  path={"/m1/reporting/days_before_tcs_web"}
                  render={props => (
                    <ReportingDaysBeforeTCS
                      report="web"
                      view={this.state.activeView}
                      {...props}
                    />
                  )}
                />
                <Route
                  path={"/m1/reporting/days_before_tcs_seminar"}
                  render={props => (
                    <ReportingDaysBeforeTCS
                      report="seminar"
                      view={this.state.activeView}
                      {...props}
                    />
                  )}
                />
                <Route
                  path={"/m1/reporting/tcs_booked_by_sales_person"}
                  render={props => (
                    <ReportingTCSBookedBySalesPerson
                      view={this.state.activeView}
                      {...props}
                    />
                  )}
                />
                <Route
                  path={"/m1/reporting/tcs_reasons"}
                  render={props => (
                    <ReportingTCSReasons
                      view={this.state.activeView}
                      {...props}
                    />
                  )}
                />
                <Route
                  path={"/m1/reporting/sales_person_results"}
                  render={props => (
                    <ReportingSalesPersonResults
                      view={this.state.activeView}
                      {...props}
                    />
                  )}
                />
                <Route
                  path={"/m1/reporting/bulk_messages"}
                  render={props => (
                    <ReportingBulkMessages
                      view={this.state.activeView}
                      {...props}
                    />
                  )}
                />
                <Route
                  path={"/m1/reporting/dead_deals"}
                  render={props => (
                    <ReportingDeadDeals
                      view={this.state.activeView}
                      {...props}
                    />
                  )}
                />
                <Route
                  path={"/m1/reporting/single_parent_attending"}
                  render={props => (
                    <ReportingSingleParentAttending
                      view={this.state.activeView}
                      {...props}
                    />
                  )}
                />
                <Route
                  path={"/m1/reporting/confirmation_call_scores"}
                  render={props => (
                    <ReportingConfirmationCallScores
                      view={this.state.activeView}
                      {...props}
                    />
                  )}
                />
                <Route
                  path={"/m1/reporting/deal_comments"}
                  render={props => (
                    <ReportingDealComments
                      view={this.state.activeView}
                      {...props}
                    />
                  )}
                />
                <Route
                  path={"/m1/reporting/download_transcripts"}
                  render={props => (
                    <ReportingDownloadTranscripts
                      view={this.state.activeView}
                      {...props}
                    />
                  )}
                />
                <Route
                  path={"/m1/reporting/:id"}
                  render={props => (
                    <ReportingSales view={this.state.activeView} {...props} />
                  )}
                />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Reporting;
